<template>
  <div class="head_wrap">
    <div class="compay_info"
         :style="{background:'url('+companyLogo+') no-repeat #29A7F4',backgroundSize:'140px',backgroundPosition:'center'}">
    </div>
    <div class="head_other">
      <!--<span class="head_item">-->
      <!--造像时代-->
      <!--<i class="el-icon-caret-bottom"></i>-->
      <!--</span>-->
      <el-popover
        placement="bottom"
        width="200"
        trigger="hover">
        <div class="whd-tcenter">
          <!-- <img src="../assets/imgs/qrcode.png" width="180" height="180" /> -->
          <img src="https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/zxgpc/images/20230826/9834ebdbc4cdc513fa3f4e7cd8f3e895.jpg" width="180" height="180" />
          <p class="font16" style="margin-bottom: 5px">造像时代</p>
          <p class="font14">全员销售，精准营销</p>
        </div>
        <el-button slot="reference" type="text" class="whd-gray666" style="margin: 0 20px; padding-left: 20px; padding-right: 20px;">APP下载</el-button>
      </el-popover>      
      <span class="head_item whd-gray666" @click="helpFn">
        <i class="el-icon-question yellow1 font20"></i>帮助中心
      </span>
      <el-dropdown class="dropdown-line" @command="handleCommand">
        <span class="el-dropdown-link">
          {{company.name}}<i class="el-icon-caret-bottom"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="password">修改密码</el-dropdown-item>
          <el-dropdown-item command="loginOut">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

  </div>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "top",
    data() {
      return {
        dialogVisible: false,
        companyLogo: 'https://b.yunzhidata.cn/static/img/logoDefult.png',
        company: {
          pic: null,
          name: null
        }
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        this.axios
            .post(api.company_index, {})
            .then(response => {
              if (response.data.code == 0) {
                this.company.pic = response.data.info.pic
                this.company.name = response.data.info.company_name
                localStorage.setItem("location", response.data.info.location)
              } else {
              }
            })
            .catch(response => {
            });
      },
      handleCommand(command) {
        if (command === 'loginOut') {
          this.axios
              .post(api.sign_out, {})
              .then(response => {
                if (response.data.code == 0) {
                  sessionStorage.removeItem('token')
                  sessionStorage.removeItem('keyid')
                  this.$router.replace('/login')
                } else {
                }
              })
              .catch(response => {
              });
        } else {
          // this.dialogVisible = true
          this.$emit('showpassword')
        }
      },
      helpFn() {
        // window.open('https://www.kancloud.cn/h1130071781/huudon/content/%E6%88%90%E4%B8%BA%E8%AE%A4%E8%AF%81%E4%BC%81%E4%B8%9A.md')
        window.open('https://www.kancloud.cn/h1130071781/yunzhi/content/%E5%85%B3%E4%BA%8E%E4%BA%91%E7%9F%A5%E6%95%B0%E6%8D%AE.md')
      }
    }
  };
</script>
